import React from "react"
import { Team } from "../components/Team"
import { TeamMembersData } from "../shared/constants"
import Layout from "../components/layout"
import SEO from "../components/SEO"
import { seoData } from "../shared/seoData"

export default class TeamContainer extends React.Component {
  render() {
    const seo = seoData.teamPage
    return (
      <>
        <SEO
          title={seo.title}
          description={seo.metaDescription}
          pathname={seo.pathname}
        />
        <Layout selectedTabValue={3}>
          <Team data={TeamMembersData} />
        </Layout>
      </>
    )
  }
}
